import groupArrow from '@/assets/images/groupArrow.svg';

export const ctaButton = (ctaText) => {
  if (!ctaText && !window.storeeelItems.isMobile) {
    // PC で CTA テキストがない場合は何も返さない
    return '';
  }

  // (1) slide-media-wrapper 用の style タグ
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    .slide-media-wrapper {
      position: relative;
      cursor: pointer;
    }
    /* CTAテキストを最大2行に制限し、超過時に省略する */
    .ctaFrame .text-wrapper {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-wrap: break-word;
      /* 2行まで表示し、それ以上は省略 */
    }
  `;

  // (2) CTA フレーム本体
  const frame = document.createElement('div');
  frame.className = 'ctaFrame';
  Object.assign(frame.style, {
    visibility: ctaText ? 'visible' : 'hidden',
    display: 'flex',
    position: 'absolute',  // 動画上に重ねる
    bottom: window.isIphone ? '10%' : '30px',
    left: '5%',
    width: '70%',
    alignItems: 'center',
    gap: '8px',
    padding: '18px 16px 18px 18px',
    background: 'var(--Black-80, rgba(39, 39, 39, 0.80))',
    borderRadius: '6px',
    border: '2px solid var(--collection-1-white-100)',
    zIndex: '10',
  });

  // (3) テキスト部分
  const textWrapper = document.createElement('div');
  textWrapper.className = 'text-wrapper';
  textWrapper.textContent = ctaText;
  Object.assign(textWrapper.style, {
    color: 'var(--White-100, #FFF)',
    fontSize: window.storeeelItems.isMobile ? '18px' : '18px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '130%',
    width: '85%',
  });

  // (4) アイコン部分
  const icon = document.createElement('img');
  icon.className = 'icon';
  icon.src = groupArrow;
  Object.assign(icon.style, {
    width: '24px',
    height: '24px',
    transform: 'rotate(180deg)',
  });

  // 組み立て
  frame.appendChild(textWrapper);
  frame.appendChild(icon);

  // HTML 文字列として返す
  return `${styleEl.outerHTML}${frame.outerHTML}`;
};
